export type NoteEnvironmentConfig = {
  hasGoogleDrive: boolean
  hasBoosterEnv: boolean
}

export type NoteEnvironmentOption = { id: string; title: string }

export const BOOSTER_ENV_TYPE: NoteEnvironmentOption = { id: 'booster-env', title: 'Booster Environment' }
export const GOOGLE_DRIVE_TYPE: NoteEnvironmentOption = { id: 'google-drive', title: 'Google Drive' }

export const getNoteEnvironmentItems = (config: NoteEnvironmentConfig): NoteEnvironmentOption[] => {
  const items: NoteEnvironmentOption[] = []

  if (config.hasGoogleDrive) {
    items.push(GOOGLE_DRIVE_TYPE)
  }

  if (config.hasBoosterEnv) {
    items.push(BOOSTER_ENV_TYPE)
  }

  return items
}
